import React from "react";
import { Link } from "react-router-dom";

function ErrorPage() {
  return (
    <div>
      Oooops, your page was not found!
      <Link to="/">Home</Link>;
    </div>
  );
}

export default ErrorPage;
